import "./Reviews.css";
import { useState, useEffect, useRef } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import gsap from "gsap";
import imge from '../Pages/images/review.JPG'
const reviews = [
  {
    id: 1,
    name: "AKHILESH REDDY",
    content: "Working with CLYRA Overseas overseas Counseling Service was a game-changer for me. CLYRA Overseas provided personalized, expert advice throughout the entire application process."
  },
  {
    id: 4,
    name: "AJAY REDDY",
    content: "I had a great experience with CLYRA Overseas Consultancy. The staff was incredibly helpful and guided me through every step of the application."
  },
  {
    id: 2,
    name: "DEVENDER REDDY",
    content: "My overall experience with CLYRA Overseas Consultancy was such an amazing ,my counselor was supportive and genuine in the part of entire process."
  },
  {
    id: 3,
    name: "SIDDU",
    content: "I have wonderful experience with CLYRA Overseas overseas for my study abroad journey to Uk. Their team provided me excellent Guidance from university selection to visa process and they were professional and patience and always available to answer my questions."
  }
];

const Reviews = () => {
  const [index, setIndex] = useState(0);
  const reviewRef = useRef(null);

  useEffect(() => {
    if (reviewRef.current) {
      gsap.fromTo(
        reviewRef.current,
        { opacity: 0, x: 50 },
        { opacity: 1, x: 0, duration: 0.5, ease: "power2.out" }
      );
    }
  }, [index]);

  const nextReview = () => {
    setIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  };

  const prevReview = () => {
    setIndex((prevIndex) => (prevIndex - 1 + reviews.length) % reviews.length);
  };

  return (
    <section className="reviews">
      <div className="review-container">
        <button onClick={prevReview} className="nav-btn left-btn"><FaArrowLeft /></button>
        <div className="review-box" ref={reviewRef}>
          <p className="review-content">{reviews[index].content}</p>
          <h3 className="review-name">- {reviews[index].name}</h3>
        </div>
        <button onClick={nextReview} className="nav-btn right-btn"><FaArrowRight /></button>
      </div>
    </section>
  );
};

export default Reviews;
